import { read, utils } from 'xlsx';

export function getAllSheetsFromXLS(blob) {
  const workbook = read(blob, { type: 'array' });

  const sheets = [];
  const sheetNames = workbook.SheetNames;
  for (const sheetName of sheetNames) {
    const sheet = {
      sheetName,
      data: utils.sheet_to_json(workbook.Sheets[sheetName], {
        header: 1,
      }),
    };
    if (sheet.data.length === 0) continue;
    sheets.push(sheet);
  }
  return sheets;
}
